import React from 'react';
import { Brain, Bell, Users, MessageCircle, Calendar, Target } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Brain,
      title: "Smart Memory",
      description: "Never forget where you met someone or what you talked about. ContaX captures and organizes every detail automatically.",
      color: "blue"
    },
    {
      icon: Bell,
      title: "Perfect Timing",
      description: "Get reminded to follow up at exactly the right moment. No more awkward late outreach or missed opportunities.",
      color: "green"
    },
    {
      icon: Users,
      title: "Rich Context",
      description: "See the full picture of each connection - their interests, mutual contacts, and conversation history at a glance.",
      color: "purple"
    },
    {
      icon: MessageCircle,
      title: "Natural Follow-ups",
      description: "AI-powered conversation starters based on your previous interactions and shared interests.",
      color: "orange"
    },
    {
      icon: Calendar,
      title: "Event Integration",
      description: "Automatically track which events you attended and who you met there. Build your networking timeline.",
      color: "indigo"
    },
    {
      icon: Target,
      title: "Goal Tracking",
      description: "Set networking goals and track your progress. Turn random meetings into strategic relationship building.",
      color: "pink"
    }
  ];

  const colorClasses = {
    blue: "bg-blue-100 text-blue-600",
    green: "bg-green-100 text-green-600",
    purple: "bg-purple-100 text-purple-600",
    orange: "bg-orange-100 text-orange-600",
    indigo: "bg-indigo-100 text-indigo-600",
    pink: "bg-pink-100 text-pink-600"
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Everything you need to build lasting
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
              professional relationships
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            ContaX transforms the way you network by giving you the tools to remember, 
            organize, and nurture every professional connection.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="group bg-gray-50 rounded-xl p-8 hover:bg-white hover:shadow-lg transition-all duration-300 border border-transparent hover:border-gray-200"
              >
                <div className={`w-12 h-12 ${colorClasses[feature.color]} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transition-shadow">
            contaX will be releasing in Q4 of 2025
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;